import { LoginScreen } from '@/components/login-screen';
import { sessionQueryOptions } from '@/lib/session-query';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/login` — entry point for unauthenticated users.
 *
 * `beforeLoad` probes the session cache (hydrated from the backend on first
 * access) and redirects to `/hills` if the user is already signed in. This
 * avoids showing the sign-in button to someone who already has a valid
 * session cookie (e.g. after hitting the browser back button post-OAuth).
 */
export const Route = createFileRoute('/login')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions());
    if (session) {
      throw redirect({ to: '/hills' });
    }
  },
  component: LoginScreen,
});
